export default class UserTranscodeNotification {
  constructor(options) {
    this.element = options.element;
    this.notice = this.element.querySelector('#js-transcode-notification--notice');
    this.warning = this.element.querySelector('#js-transcode-notification--warning');
    this.error = this.element.querySelector('#js-transcode-notification--error');
    this.closeButton = this.element.querySelector('#js-transcode-notification--close');
  }

  init() {
    document.addEventListener('user.data.loaded', this.userDataLoaded.bind(this));
    this.closeButton.addEventListener('click', this.closeNotification.bind(this));
  }

  userDataLoaded() {
    if (!window.currentUser) return;
    if (window.currentUser.transcode_status == null) return;
    this.element.classList.remove('hide-me');

    if (window.currentUser.transcode_status == 'success') {
      this.notice.classList.remove('hide-me');
      this.notice.innerText = 'Selamat! Video kamu sukses diunggah';
    }
    else if (window.currentUser.transcode_status == 'processing') {
      this.warning.classList.remove('hide-me');
      this.warning.innerText = 'Video kamu sedang dalam proses unggah';
    }
    else if (window.currentUser.transcode_status == 'need_more_time') {
      this.warning.classList.remove('hide-me');
      this.warning.innerText = 'Maaf, proses unggah video kamu membutuhkan waktu lebih lama';
    }
    else if (window.currentUser.transcode_status == 'failed') {
      this.error.classList.remove('hide-me');
      this.error.innerText = 'Oops! Terjadi kendala proses unggah';
    }
  }

  closeNotification() {
    this.element.classList.add('hide-me');
    this.notice.classList.add('hide-me');
    this.warning.classList.add('hide-me');
    this.error.classList.add('hide-me');

    this.deleteNotification();
  }

  deleteNotification(){
    let xhr = new XMLHttpRequest();
    xhr.open('DELETE', '/interactions/last_transcode_notification');
    let csrfTokenElement = document.querySelector('meta[name=csrf-token]');
    if(csrfTokenElement)
      xhr.setRequestHeader('X-CSRF-Token',csrfTokenElement.content);
    xhr.send();
  }
}
